export const AUTH_RECORDING_DATA_REQUEST = "AUTH_RECORDING_DATA_REQUEST";
export const AUTH_RECORDING_DATA_SUCCESS = "AUTH_RECORDING_DATA_SUCCESS";
export const AUTH_RECORDING_DATA_FAIL = "AUTH_RECORDING_DATA_FAIL";
export const AUTH_RECORDING_DATA_RESET = "AUTH_RECORDING_DATA_RESET";
